if (process.env.REACT_APP_NODE_ENV !== "development") {
    console.log = function () {};
    console.warn = function () {};
    console.error = function () {};
    console.debug = function () {};
}